module.exports = __webpack_public_path__ + "img/hp-m4-cyan.4eb84216.png";